import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { produce } from 'immer';

type NotificationStore = {
  isAllowedNotification: boolean;
  soundOn: boolean;
  changeIsAllowedNotification: (on: boolean) => void;
  changeSoundOn: (on: boolean) => void;
};

const useNotificationStore = create<NotificationStore>()(
  persist(
    devtools((set) => ({
      isAllowedNotification: false,
      soundOn: false,
      changeIsAllowedNotification(on) {
        set(
          produce((draft: NotificationStore) => {
            draft.isAllowedNotification = on;
          }),
        );
      },
      changeSoundOn(on) {
        set(
          produce((draft: NotificationStore) => {
            draft.soundOn = on;
          }),
        );
      },
    })),
    {
      name: 'NOTIFICATION',
    },
  ),
);

export default useNotificationStore;
